import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as Swal from 'sweetalert2/dist/sweetalert2.js'
import { AuthService } from './auth.service';
import * as $ from 'jquery';
declare var Highcharts: any;

@Injectable({
  providedIn: 'root'
})
export class CstemapiService {
  // public mainurl = 'https://beta.cstep.in/cstem-service-test/'; /* Testing */
  // public mainurl = 'https://beta.cstep.in/cstem-service-dev/'; /* Development */
  public mainurl = 'https://beta.cstep.in/cstem-service-prod/'; /* Production */
 public assetUrl = 'https://beta.cstep.in/assets/cstem/';
 
  httpOptions = {
    headers: new HttpHeaders({
      'Authorization': 'Basic ' + btoa('cstepuser:C5t39^53r#')
    })
  };
  public Swal = Swal;

  public monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  public h_x_y_format = {
    fontSize: '1rem',
    color: '#000000'
  }

  public h_x_y_title_format = {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#000000'
  }

  public h_x_y_tooltip_format = {
    fontSize: '14px',
    color: '#000000'
  }

  public h_title_format = {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: '#000000'
  }
  constructor(private http: HttpClient, private auth: AuthService) {
    Highcharts.setOptions({
      chart: {
        style: {
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
        }
      }
    });
  }

  disablechart() {
    Highcharts.setOptions({
      exporting: {
        buttons: {
          contextButton: {
            enabled: false
          }
        }
      }
    });
  }

  enablechart() {
    Highcharts.setOptions({
      exporting: {
        buttons: {
          contextButton: {
            enabled: true,
            menuItems: [
              "viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator",
              "downloadCSV",
              "downloadXLS"
            ]
          }
        }
      }
    });
  }

  cstemAPI(dObj) {
    if (this.auth.getGuestUserId() != '' && this.auth.getIsGuest() == 'true') {
      /* guest user with new simulation */
      // console.log("is demo ----------------")
      dObj['guestUserId'] = this.auth.getGuestUserId();
    }
    if (this.auth.getIsDemo() == 'true') {
      // console.log("is demo")
      /* guest user with demo */
      dObj['guestUserId'] = this.auth.getGuestUserId();;
      dObj['userId'] = this.auth.getUserId();
    }
    // console.log(JSON.stringify(dObj))
    return {
      Login: this.http.post(this.mainurl + 'profile/login', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      UserInfo: this.http.post(this.mainurl + 'profile/getUserDetails', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      SignUp: this.http.post(this.mainurl + 'profile/registerNewUser', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GenerateOTP: this.http.post(this.mainurl + 'profile/generateOtp', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      ValidateOTP: this.http.post(this.mainurl + 'profile/validateOtp', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      ForgotPassword: this.http.post(this.mainurl + 'profile/forgotPassword', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      CreatePassword: this.http.post(this.mainurl + 'profile/changePassword', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      ChangePassword: this.http.post(this.mainurl + 'profile/changePassword', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      UserType: this.http.post(this.mainurl + 'profile/getUserTypeDetails', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      Feedback: this.http.post(this.mainurl + 'profile/provideFeedback', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetTechnologyType: this.http.post(this.mainurl + 'inputValues/getTechnologyType', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetAlbidoFactor: this.http.post(this.mainurl + 'inputValues/getAlbidoFactor', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetModulemanufacturesDetails: this.http.post(this.mainurl + 'inputValues/getManufacturer', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetModelDetails: this.http.post(this.mainurl + 'inputValues/getModelDetails', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetModuleTypeDetails: this.http.post(this.mainurl + 'inputValues/getModuleTypeDetails', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetMountConfiguration: this.http.post(this.mainurl + 'inputValues/getMountConfiguration', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetMountTypeDetails: this.http.post(this.mainurl + 'inputValues/getMountTypeDetails', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetPCUApplicationTypes: this.http.post(this.mainurl + 'inputValues/getPCUApplicationTypes', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetPCUManufacturer: this.http.post(this.mainurl + 'inputValues/getPCUManufactureDetails', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetPCUmodelDetails: this.http.post(this.mainurl + 'inputValues/getPCUModelDetails', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetSolarAngle: this.http.post(this.mainurl + 'reports/GetSolarAnglesRequest', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetRadiationSummaryReport: this.http.post(this.mainurl + 'reports/getRadiationSummaryReport', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetRadiationData: this.http.post(this.mainurl + 'reports/getRadiationData', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetClimateData: this.http.post(this.mainurl + 'reports/getClimateData', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetSimulatedPlantList: this.http.post(this.mainurl + 'reports/getSimulatedPlantsList', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetPlantSummaryReport: this.http.post(this.mainurl + 'reports/getPlantSummaryReport', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetPlantSizingDetails: this.http.post(this.mainurl + 'reports/getPlantSizingDetails', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetTimeWindowBasedAnalysis: this.http.post(this.mainurl + 'reports/timeWindowBasedAnalysis', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetTimeWindowBasedSummary: this.http.post(this.mainurl + 'reports/timeWindowBasedAnalysisSummary', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetEnergyFlowDetails: this.http.post(this.mainurl + 'reports/getEnergyFlowDetails', dObj, this.httpOptions).pipe(catchError(this.handleError)),

      // 3 Different request for same method - because sometimes it returns null
      GetMonthlyAggregatePVGeneration: this.http.post(this.mainurl + 'reports/getAggregatePvGeneration', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetDailyAggregatePVGeneration: this.http.post(this.mainurl + 'reports/getAggregatePvGeneration', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetHourlyAggregatePVGeneration: this.http.post(this.mainurl + 'reports/getAggregatePvGeneration', dObj, this.httpOptions).pipe(catchError(this.handleError)),

      GetHourlyDistributionOfPV: this.http.post(this.mainurl + 'reports/hourlyDistributionOfPv', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetHourWiseRangeGenerationOfPV: this.http.post(this.mainurl + 'reports/hourWiseRangePvGeneration', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetHourwiseDistributionAggGeneration: this.http.post(this.mainurl + 'reports/hourWiseDistributionAggGeneration', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetDegradtionReport: this.http.post(this.mainurl + 'reports/getDegradationReport', dObj, this.httpOptions).pipe(catchError(this.handleError)),

      GetBaseCaseSummary: this.http.post(this.mainurl + 'fReports/getBaseCaseSummary', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetCapitalCostSummary: this.http.post(this.mainurl + 'fReports/getCapitalCostSummary', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetLCOESummary: this.http.post(this.mainurl + 'fReports/getLCOESummary', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetIrrSummary: this.http.post(this.mainurl + 'fReports/getIrrSummary', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetYearonYearData: this.http.post(this.mainurl + 'fReports/getYearOnYearData', dObj, this.httpOptions).pipe(catchError(this.handleError)),

      Simulate: this.http.post(this.mainurl + 'compute/simulate', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetBatteryBrand: this.http.post(this.mainurl + 'inputValues/getBatteryBrandDetails', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetBatteryType: this.http.post(this.mainurl + 'inputValues/getBatteryTypeDetails', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetBatteryReport: this.http.post(this.mainurl + 'reports/getBatteryReport', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetBatteryWeekReport: this.http.post(this.mainurl + 'reports/getBatteryWeekelyReports', dObj, this.httpOptions).pipe(catchError(this.handleError)),

      allpublication: this.http.post('https://www.cstep.in/drupal/api/air_publication?_format=json', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetBatteryAggregateReport: this.http.post(this.mainurl + 'reports/getBatteryAggregateReport', dObj, this.httpOptions).pipe(catchError(this.handleError)),

      /* stats */
      GetApplicationCaseCount: this.http.post(this.mainurl + 'statistics/getApplicationCaseCount', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetFinancialCaseCount: this.http.post(this.mainurl + 'statistics/getFinancialCaseCount', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetRegisterdUserCount: this.http.post(this.mainurl + 'statistics/getRegisteredUserCount', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetRoleBasedLogin: this.http.post(this.mainurl + 'statistics/getRoleBasedLogin', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetSimulatedCaseCount: this.http.post(this.mainurl + 'statistics/getSimulatedCaseCount', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetUserVisitCount: this.http.post(this.mainurl + 'statistics/getUserVisitCount', dObj, this.httpOptions).pipe(catchError(this.handleError)),
      GetRegisterUserCount: this.http.post(this.mainurl + 'statistics/getRegisteredUserCount', dObj, this.httpOptions).pipe(catchError(this.handleError)),

      GetGoogleAuthToken: this.http.post('https://www.googleapis.com/oauth2/v3/token', dObj).pipe(catchError(this.handleError)),

    }
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${JSON.stringify(error.error)}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

  printReqRes(req, res, api) {
    console.log("----------------------------------------------------")
    console.log('Service - ', this.mainurl)
    console.log('API - ', api)
    console.log('Request - ', JSON.stringify(req));
    console.log('Response - ', res);
  }
  // encrypt(obj) {
  //   var Buffer = require("buffer").Buffer;
  //   // let objJsonStr = JSON.stringify(obj);
  //   let objJsonStr = obj;
  //   let objJsonB64 = Buffer.from(objJsonStr).toString("base64");
  //   var s1 = objJsonB64.slice(10, 20);
  //   var final = s1.slice(0, 5) + objJsonB64 + s1.slice(5, 10);
  //   console.log(final)
  //   return final;
  // }

  // decrypt(obj) {
  //   var Buffer = require("buffer").Buffer;
  //   let objJsonStr = JSON.stringify(obj);
  //   let objJsonB64 = Buffer.from(objJsonStr).toString("base64");
  //   var s1 = objJsonB64.slice(10, 20);
  //   var final = s1.slice(0, 5) + objJsonB64 + s1.slice(5, 10);
  //   return final;
  // }

  tooltip() {
    return {
      capacity_based: 'For a target DC plant capacity',
      area_based: 'For polygon area drawn in the map',
      grid_connected_utility_plant: '0.5 to 5000 MW',
      mini_grid: '10 to 500 kW',
      basic_viability: 'This includes determining the basic financial parameters, debt serviceability Levelised Cost of Energy (LCOE) and Internal Rate Return (IRR)',
      bid: 'This includes determining the basic financial viability and the profitability of the proposed bid',
      fit: 'This includes determining the basic financial viability and the profitability of the proposed Feed In Tariff',
      fixedpanel: 'Fixed module tilt (no tracking)',
      capacity_inp: {
        min: '0.5',
        max: '5000',
        default: '1'
      },
      capacity_inp_minigrid: {
        min: '0.01',
        max: '0.5',
        default: '0.01'
      },
      tilt_angle_inp: {
        min: 0,
        max: 90,
        tooltip: 'It is tilt of the PV array; typical consideration is to set the tilt of the module to be equal to the latitude of the location'
      },
      surface_azimuth_angle_inp: {
        min: -180,
        max: 180,
        default: 0,
        tooltip: 'This parameter accounts for the orientation of the PV array with respect to the geographical south. Typical consideration in India is to orient the PV arrays due south'
      },
      plant_life_inp: {
        min: 5,
        max: 40,
        default: 25
      },
      reference_area_inp: {
        min: 1,
        max: 30,
        default: 5
      },
      user_defined_scaling_factor: {
        min: -180,
        max: 180,
        default: 0,
        tooltip: 'user_defined_scaling_factor'
      },
      array_height_inp: {
        min: 1.25,
        max: 1.5,
        default: 1.5,
        tooltip: 'The allowable structure height ranges from 1.25 to 1.5 m. This has been set in discussion with industry experts considering the ease of cleaning the panels'
      },
      ground_clearence_inp: {
        min: 0.5,
        max: 0.75,
        default: 0.5,
        tooltip: 'The ground clearance is the height at which the PV arrays are set to minimise soiling effects. Based on inputs with industry experts this is typically set at about 0.5 to 0.75 m from ground level'
      },
      bspacing_length_inp: {
        min: 1,
        max: 10,
        default: 10
      },
      bspacing_breadth_inp: {
        min: 1,
        max: 10,
        default: 10
      },
      due_to_soiling_inp: {
        min: 0,
        max: 50,
        default: 5
      },
      electrical_losses_inp: {
        min: 0,
        max: 25,
        default: 8
      },
      module_rating_at_end: {
        min: 50,
        max: 100,
        default: 97
      },
      year_on_year_degradtion_rate: {
        min: 0,
        max: 10,
        default: 0.67
      },
      for_utility_plant: {
        min: 0,
        max: 15,
        default: 1,
        tooltip: 'As a percentage of annual generation at the end of year 1 '
      },
      battery_load_peak: {
        min: 0,
        max: 1.5,
        default: 1
      },
      capital_module_price: {
        min: 0,
        max: 1000,
        default: 21,
        tooltip: 'Inclusive of custom clearing charges, transportation and unloading.'
      },
      capital_battery: {
        min: 0,
        max: 100000,
        default: 8000,
        tooltip: 'Overhaul costs not factored and are considered additionally based on discounted price as per year of replacement '
      },
      capital_land: {
        min: 0,
        max: 1000,
        default: 5,
        tooltip: 'Typically land deployed for these projects is barren in nature'
      },
      capital_mounting_structure: {
        min: 0,
        max: 1000,
        default: 30,
        tooltip: 'Includes structural and support material requirements'
      },
      capital_civil: {
        min: 0,
        max: 1000,
        default: 25,
        tooltip: 'Includes site preparation as such as levelling and mounting, building control room, approach roads, fencing or boundary wall, cable trenching, arranging water supply, lighting etc. General works include security of solar farm, setting up of power backup generator; yard lighting, earthing kits, etc'
      },
      capital_pcu: {
        min: 0,
        max: 1000,
        default: 30,
        tooltip: 'Includes all taxes, duties and major overhaul cost in 14th  year of operation'
      },
      capital_power: {
        min: 0,
        max: 1000,
        default: 40,
        tooltip: 'Includes DC and AC cabling costs between various equipments, metering and monitoring equipments  and all entities in the substation'
      },
      capital_preoperative: {
        min: 0,
        max: 1000,
        default: 35,
        tooltip: 'Includes transportation of equipment, Storage of equipment at site, insurance, taxes, duties, Interest During Construction (IDC), financing costs and other project management costs'
      },
      capital_miscellaneous: {
        min: 0,
        max: 1000,
        default: 30,
        tooltip: 'Includes contingency and any other expenses not covered in the above categories'
      },
      operation_cost: {
        min: 0,
        max: 1000,
        default: 10,
        tooltip: 'tooltip'
      },
      operation_escalation: {
        min: 0,
        max: 50,
        default: 5.72
      },
      subsidy_bulk_capital: {
        min: 0,
        max: 100,
        default: 0
      },
      feed_in_tarrif_fit: {
        min: 0,
        max: 100,
        default: 0
      },
      target_bid: {
        min: 0,
        max: 100,
        default: 0
      },
      loan_related_debt: {
        min: 0,
        max: 100,
        default: 70,
        tooltip: 'Share of capital cost considered as debt'
      },
      loan_related_terms: { /* change */
        min: 0,
        max: 25,
        default: 10
      },
      loan_related_moratorium_period: {  /* change */
        min: 0,
        max: 100,
        default: 1
      },
      loan_related_interest: {
        min: 0,
        max: 20,
        default: 8.5
      },
      loan_related_capital_interest: {
        min: 0,
        max: 10,
        default: 8.5
      },
      depreciation_loan_term: {
        min: 0,
        max: 50,
        default: 5.80
      },
      return_equity_loan_term: {
        min: 0,
        max: 100,
        default: 20
      },
      return_equity_post_loan: {
        min: 0,
        max: 100,
        default: 24
      },
      taxes_income_tax_rate: {
        min: 0,
        max: 50,
        default: 34
      },
      taxes_alternative_tax: {
        min: 0,
        max: 50,
        default: 20
      },
      battery_max_soc: {
        min: 0.1,
        max: 1,
        default: 0.8
      },
      battery_min_soc: {
        min: 0.1,
        max: 1,
        default: 0.3
      },
      referencevoltage: {
        tooltip: 'The PCU reference voltage is used to design the PV arrays in series and hence aid in designing the number of panels per PCU'
      },
      tarrifonbuyofenergy: {
        min: 0,
        max: 20,
        default: 6,
        tooltip: 'tooltip'
      },
      pvModuleModel: {
        tooltip: 'Refers to the STC rating of the PV module'
      },
      pvInverter: {
        tooltip: 'PCU AC power Rating'
      }
    }
  }
}
